export * from './resource-not-found-notice.module';
export * from './resource-not-found-notice.component';
